import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { useScheduledMetaEnrichmentContext } from '~/features/content-enrichment/adapters/scheduled-meta-enrichment-adapter';
import { EnrichmentCtx } from '~/features/content-enrichment/context/enrichment-context';
import { requireFeatureGate } from '~/utils/guards';

const ContentEnrichmentLayout = lazy(
  () => import('~/features/content-enrichment/pages/content-enrichment-layout'),
);

/**
 * Provider wrapper that builds the Meta Ads scheduled-enrichment context and
 * injects it into the shared funnel tree. Keeps the route file responsible
 * only for wiring — all Meta-specific logic lives in the adapter hook.
 */
function MetaAdsEnrichmentProvider() {
  const ctx = useScheduledMetaEnrichmentContext();
  return (
    <EnrichmentCtx.Provider value={ctx}>
      <ContentEnrichmentLayout />
    </EnrichmentCtx.Provider>
  );
}

/** Layout route for the Meta Ads content-enrichment funnel. URL: `/enrichments/meta/content-enrichment/...`. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId',
)({
  beforeLoad: requireFeatureGate('meta_ads'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <MetaAdsEnrichmentProvider />
    </Suspense>
  ),
});
